import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { formatValue } from "../../../utilities";
import styleConstants from "../../../styleConstants";
import StackedColumnChart from "../../chart/StackedColumnChart";

const CumulativeGapByGniGroupChart = props => {
  const data = props.data;

  return (
    <div>
      <StackedColumnChart
        ref={props.innerRef}
        height={styleConstants.stackedBarHeight}
        categories={["Total", "Donor", "Gov't", "Private"]}
        series={[
          {
            name: "LIC",
            color: styleConstants.categoryColors.gniGroupColors["LIC"],
            data: data
              .filter(datum => datum.area === "Low-Income (LIC)")
              .map(datum => datum.value)
          },
          {
            name: "L-MIC",
            color: styleConstants.categoryColors.gniGroupColors["L-MIC"],
            data: data
              .filter(datum => datum.area === "Lower-Middle-Income (L-MIC)")
              .map(datum => datum.value)
          },
          {
            name: "U-MIC",
            color: styleConstants.categoryColors.gniGroupColors["U-MIC"],
            data: data
              .filter(datum => datum.area === "Upper-Middle-Income (U-MIC)")
              .map(datum => datum.value)
          }
        ]}
        reversedLegend={true}
        plotLineValues={[0.5]}
        absolute={props.absolute}
        tooltipFormatter={function() {
          return `${this.series.name} Gap: <strong>$${formatValue(
            this.y
          )}</strong><br />Share of ${this.key} Gap: <strong>${formatValue(
            this.percentage / 100,
            true
          )}</strong>`;
        }}
      />
    </div>
  );
};

CumulativeGapByGniGroupChart.propTypes = {
  data: PropTypes.array.isRequired,
  absolute: PropTypes.bool
};

export default memo(
  React.forwardRef((props, ref) => (
    <CumulativeGapByGniGroupChart innerRef={ref} {...props} />
  ))
);
